/**
 * File: ActualsUnplannedModel.js
 *
 * Model layer for Actuals page. Handles fetching what
 * is needed for this page and presenting it in a useful
 * form to the controller
 */
(function(){
    angular
        .module('maApp.view.pages')
        .factory('ActualsUnplannedModel', ActualsUnplannedModel);

    ActualsUnplannedModel.$inject = ['$q','UnitsRequest', 'ActionsRequest', 'PlansRequest', 'PlannedActionsRequest', '$timeout', '$log'];

    function ActualsUnplannedModel($q, UnitsRequest, ActionsRequest, PlansRequest, PlannedActionsRequest, $timeout, $log){
        var newUnplannedActualModel = {
            'unit':null,
            'category':null,
            'action':null,
            'startdate':null,
            'enddate':null,
            'pctaffected':null,
            'costestimated':0,
            'costactual':null,
            'actionnote':null
        };

        var viewModel = {
            planId:null,
            project:null,
            unplannedActuals:[],
            newUnplannedActual:angular.copy(newUnplannedActualModel)
        };

        return {
            'fetch':fetchModel,
            'save':saveModel,
            'deleteUnplannedActual':deleteUnplannedActual
        };

        function saveModel(vm){
            var firstRequest = $timeout(function(){}, 0);
            if(!vm.planId){
                //create an event
                firstRequest = PlansRequest.post({
                    project: vm.project,
                    year: Date.create().getFullYear().toString(),
                    isactual:1,
                    //composite: null,    //aka Prescription
                    name: Date.now().toString()   //make a unique name for the plan
                })
                    .then(loadPlan);
                function loadPlan(plan){
                    plan = plan[0];
                    vm.planId = plan.id;
                    $log.debug('plan created', plan);
                    return plan;
                }
            }
            return firstRequest.then(saveActual);

            function saveActual(){
                //now that we're sure there is a planId, we can save the actual
                return PlannedActionsRequest.Actual.put(
                    vm.project,
                    vm.planId,
                    vm.newUnplannedActual.unit.id,
                    vm.newUnplannedActual.action.id,
                    Date.create(vm.newUnplannedActual.startdate).format(Date.ISO8601_DATE), {
                        'enddate':Date.create(vm.newUnplannedActual.enddate).format(Date.ISO8601_DATE),
                        'pctaffected':vm.newUnplannedActual.pctaffected,
                        'costestimated':vm.newUnplannedActual.costestimated,
                        'costactual':vm.newUnplannedActual.costactual,
                        'actionnote':vm.newUnplannedActual.actionnote
                    })
                        .then(loadUnplannedActual)
                        .then(resetNewUnplannedActual);

                function loadUnplannedActual(unplannedActual){
                    unplannedActual = unplannedActual[0];
                    unplannedActual.unit = _.findWhere(vm.units, {'id':unplannedActual.samplingunitid});
                    unplannedActual.action = _.findWhere(vm.actions, {'id':unplannedActual.actionid});
                    $log.debug('loading unplanned actual', unplannedActual);
                    vm.unplannedActuals.push(unplannedActual);
                }

                function resetNewUnplannedActual(){
                    vm.newUnplannedActual = angular.copy(newUnplannedActualModel);
                }

            }

        }

        function fetchModel(project){
            viewModel.project = project;
            var promises = [];
            promises.push( fetchProjectUnits(viewModel.project) );
            promises.push( fetchActions() );
            promises.push(  fetchProjectUnplannedActuals(viewModel.project)  );
            return $q.all(promises)
                .then(createViewModelFromRequests);

            function createViewModelFromRequests(responses){

                var newViewModel = angular.copy(viewModel);

                newViewModel.units = responses[0];
                newViewModel.actions = responses[1];
                newViewModel.unplannedActuals =
                    addMetadataToProjectUnplannedActuals(responses[2], newViewModel.units, newViewModel.actions);

                return newViewModel;
            }
        }

        function deleteUnplannedActual(project, unplannedActual){
            return PlannedActionsRequest.Actual.delete(
                project,
                unplannedActual.id,
                unplannedActual.action.id,
                unplannedActual.unit.id,
                unplannedActual.startdate
            );
        }

        function fetchProjectUnits(project){
            return UnitsRequest.get(project);
        }

        function fetchActions(){
            return ActionsRequest.get({
                active: 1
            });
        }

        function fetchProjectUnplannedActuals(project){
            return PlannedActionsRequest.Actual.get('unplanned', project, null, null);
        }

        function addMetadataToProjectUnplannedActuals(unplannedActuals, projectUnits, projectActions){
            for(var i=0;i<unplannedActuals.length;i++){
                unplannedActuals[i].action = _.findWhere(projectActions, {'id':unplannedActuals[i].actionid});
                unplannedActuals[i].unit = _.findWhere(projectUnits, {'id':unplannedActuals[i].samplingunitid});
            }
            return unplannedActuals;
        }


    }
})();